import { useEffect, useRef } from "react";
import { useMenu, UseMenuProps } from "react-instantsearch";


const transformItems: UseMenuProps['transformItems'] = (items) => {

    const categoryOrder : {[category: string]: number} = {
        "All": 0,
        "Fabric": 1,
        "Laminate & Wood": 2,
        "Paint": 3,
        "More Surfaces": 4
    }

    const allCount = items.reduce((sum, item) => sum + item.count, 0);
   
    return [ { label: "All", value: "", isRefined: !items.some((item) => item.isRefined), count: allCount },
            ...items,
        ].sort((a, b) => {
            const categoryA = categoryOrder[a.label];
            const categoryB = categoryOrder[b.label];
            return categoryA - categoryB;
    });

}

interface CategoryFilters {
    setSelectedCategory: (category: string) => void
    setSelectedCount: (count: number) => void
}

export default function CategoryFilters({ setSelectedCategory, setSelectedCount }: CategoryFilters) {
    const menuApi = useMenu({
        attribute: 'filters.category',
        transformItems: transformItems
    });

    const isFirstRun = useRef(true);
    
    useEffect(() => {
        if(isFirstRun.current) {
            isFirstRun.current = false;
            return;
        } else {
            let count = 0;
            menuApi.items.map(item => {
                if(item.isRefined) {
                    if(item.label == "All") {
                        menuApi.items.forEach((item) => {
                            count += item.label !== "All" ? item.count : 0
                        })
                    } else {
                        count += item.count
                    }
                }
            })
            setSelectedCount(count)
        }
        

    }, [isFirstRun.current, menuApi])

    return (
        <div>
            <ul className={"search-page__flex-container"}>
                {menuApi.items.map((item) => {
                    return (
                        <li 
                            className={`search-page__menu-item ${item.isRefined ? "search-page__menu-item--active" : ""}`} 
                            onClick={() => {
                                if (item.value === "") {
                                    menuApi.refine("");
                                    setSelectedCategory(item.label)
                                    setSelectedCount(item.count)
                                  } else {
                                    menuApi.refine(item.value);
                                    setSelectedCategory(item.label)
                                    setSelectedCount(item.count)
                                  }
                            }}
                        >
                            <span className={"search-page__menu-item-text"}>
                                <span>{item.label === "All" && window.steelcase_i18n["steelcase-finish-library"].all ? window.steelcase_i18n["steelcase-finish-library"].all : item.label}</span> <span> ({item.count})</span>
                            </span>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}